

export function playSfx(sfx) {
    let track = new Audio(sfx);
    track.type = "audio/mp3";
    track.play();
}

export default playSfx;